import React from 'react';
import { styled } from '@glitz/react';
import FacetValueViewModel from 'Shared/Facet/FacetValueViewModel.type';
import * as style from 'Shared/Style';
import Image, { Ratio as ImageRatio } from 'Shared/Image/Ratio';
import { TextInline, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';

type PropType = { value: FacetValueViewModel; toggleSelected: () => void };

const OptionCardWrap = styled.div({
  background: style.colors.monochrome.white,
  border: {
    xy: {
      width: '1px',
      style: 'solid',
      color: style.colors.monochrome.white,
    },
  },
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.15)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: { x: '12px', y: '14px' },
  gap: '4px',
  cursor: 'pointer',
})

const OptionCardWrapSelected = styled(OptionCardWrap, {
  border: {
    xy: {
      color: style.colors.monochrome.black,
    },
  },
})

const OptionCardImage = styled(Image, {
  width: '16px',
})

const IconText = styled(TextInline, {
  textAlign: 'center',
  display: 'block',
  width: '100%',
})

const Text = styled(TextInline, {
  textAlign: 'center',
})

const OptionCard = ({ value, toggleSelected }: PropType) => {

  const TextElement = value.icon ? IconText : Text;
  const Wrap = value.selected ? OptionCardWrapSelected : OptionCardWrap;

  return (
    <Wrap
      onClick={toggleSelected}
      css={{
        justifyContent: value.icon ? 'left' : 'center',
      }}
    >
      {value.icon && (
        <OptionCardImage
          src={{ url: value.icon?.url }}
          alt={value.displayName}
          ratio={ImageRatio.OneToOneFill}
        />
      )}
      <TextElement fontSize={ResponsiveSize.D12_M12} upperCase>
        {value.displayName}
      </TextElement>
    </Wrap>
  );
};

const ColorOptionCardWrap = styled.div({
  background: style.colors.monochrome.white,
  border: {
    xy: {
      width: '1px',
      style: 'solid',
      color: style.colors.monochrome.white
    },
  },
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.15)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: { x: '12px', y: '14px' },
  gap: '8px',
  cursor: 'pointer',
})

const ColorOptionCardWrapSelected = styled(ColorOptionCardWrap, {
  border: {
    xy: {
      color: style.colors.monochrome.black,
    },
  },
})

const ColorCircle = styled.div({
  width: '24px',
  height: '24px',
  border: {
    xy: {
      width: '1px',
      style: 'solid',
      color: 'rgba(0, 0, 0, 0.3)',
    },
  },
  borderRadius: '48px',
})

export const ColorOptionCard = ({ value, toggleSelected }: PropType) => {
  const Wrap = value.selected ? ColorOptionCardWrapSelected : ColorOptionCardWrap;

  return (
    <Wrap onClick={toggleSelected}>
      <ColorCircle css={{ background: value.id, }} />
      <TextInline fontSize={ResponsiveSize.D10_M10} upperCase>
        {value.displayName}
      </TextInline>
    </Wrap>
  );
};

export default OptionCard;
